import React from 'react';
import {Image, StyleSheet} from 'react-native';
import Div from '../lib/Div';
import P from '../lib/P';
import closeCircleIcon from '../assets/img/icons/close-circle.svg';
import MainStyle from '../../MainStyle';
import Btn from './Btn';

type Props = {
  onCancel: () => void;
};

const WaitingForShotIndicator = ({onCancel}: Props) => {
  return (
    <Div alignItems="center" justifyContent="center" mt={20}>
      <Btn h={80} w={80} bg="#163074" rounded={80} row justifyContent="center" alignItems="center" mb={10} onPress={onCancel}>
        <Div h={33} w={33} justifyContent="center" alignItems="center">
          <Image source={closeCircleIcon as any} style={{width: 33, height: 33}}/>
        </Div>
      </Btn>
      <P style={styles.waitingForShotTapToCancel}>Waiting for shot. Tap to cancel.</P>
    </Div>
  );
};

export default WaitingForShotIndicator;

const styles = StyleSheet.create({
  waitingForShotTapToCancel: {
    color: "#FFF",
    textAlign: "center",
    textShadow: "0 4px 25px rgba(0, 0, 0, 0.40)",
    fontSize: 16,
    fontStyle: "normal",
    ...MainStyle.DavisSans400
  }
});
